import CONTRATO_FECHAS from '@/graphql/querys/administracion/contratos/fechas/contratoFechas.gql';
import AGREGAR_CONTRATO_FECHA from '@/graphql/mutations/administracion/contratos/contrato/fechas/agregarContratoFecha.gql';
import ACTUALIZAR_CONTRATO_FECHA from '@/graphql/mutations/administracion/contratos/contrato/fechas/actualizarContratoFecha.gql';
import REMOVER_CONTRATO_FECHA from '@/graphql/mutations/administracion/contratos/contrato/fechas/removerContratoFecha.gql';

export default {
  data() {
    return {
      tipos: [
        {
          id: 'fecha-de-entrega-de-proyecto',
          name: 'Fecha de Entrega de Proyecto',
          seRepite: false,
        },
        {
          id: 'fecha-de-entrega-de-sitio',
          name: 'Fecha de entrega de Sitio',
          seRepite: false,
        },
        {
          id: 'fecha-aviso-de-terminacion',
          name: 'Fecha Aviso de Terminación',
          seRepite: false,
        },
        {
          id: 'fecha-de-verificacion-de-los-trabajos',
          name: 'Fecha de Verificación de los Trabajos',
          seRepite: false,
        },
        {
          id: 'fecha-de-recepcion-de-trabajos',
          name: 'Fecha de Recepción de Trabajos',
          seRepite: false,
        },
        {
          id: 'fecha-de-cierre-de-bitacora',
          name: 'Fecha de Cierre de Bitácora',
          seRepite: false,
        },
        {
          id: 'fecha-de-acta-finiquito',
          name: 'Fecha de Acta Finiquito',
          seRepite: false,
        },
        {
          id: 'fecha-de-acta-de-extincion',
          name: 'Fecha de Acta de Extinción',
          seRepite: false,
        },
        {
          id: 'fecha-de-entrega-de-obra',
          name: 'Fecha de Entrega de Obra',
          seRepite: false,
        },
        {
          id: 'fecha-de-suspension-de-trabajos',
          name: 'Fecha de Suspensión de Trabajos',
          seRepite: true,
        },
        {
          id: 'fecha-de-reinicio-de-trabajos',
          name: 'Fecha de Reinicio de Trabajos',
          seRepite: true,
        },
        {
          id: 'fecha-solicitud-terminacion-anticipada',
          name: 'Fecha Solicitud Terminación Anticipada',
          seRepite: false,
        },
        {
          id: 'fecha-de-terminacion-anticipada',
          name: 'Fecha de Terminación Anticipada',
          seRepite: false,
        },
        {
          id: 'fecha-inicio-de-rescision-administrativa',
          name: 'Fecha Inicio de Rescisión Administrativa',
          seRepite: false,
        },
        {
          id: 'fecha-de-resciscion-administrativa',
          name: 'Fecha de Rescisción Administrativa',
          seRepite: false,
        },
      ],
    };
  },
  methods: {
    async mixRegistrarContratoFecha() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_FECHA,
          variables: {
            fecha: this.fecha,
          },
          update: (store, { data: { agregarContratoFecha } }) => {
            const query = {
              query: CONTRATO_FECHAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoFechas } = store.readQuery(query);
            const contratoFechasCopia = contratoFechas.slice();
            contratoFechasCopia.push(agregarContratoFecha);
            store.writeQuery({
              ...query,
              data: {
                contratoFechas: contratoFechasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixActualizarContratoFecha() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_FECHA,
          variables: {
            id: this.fechaEditar.id,
            fecha: this.fecha,
          },
          update: (store, { data: { actualizarContratoFecha } }) => {
            const query = {
              query: CONTRATO_FECHAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoFechas } = store.readQuery(query);
            const index = contratoFechas.findIndex(({ id }) => id === this.fechaEditar.id);
            if (index !== -1) {
              contratoFechas.splice(index, 1, actualizarContratoFecha);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoFechas,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixEliminarContratoFecha() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: REMOVER_CONTRATO_FECHA,
          variables: {
            id: this.id,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_FECHAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoFechas } = data;
            const index = contratoFechas.findIndex((gasto) => gasto.id === this.id);
            if (index !== -1) {
              contratoFechas.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    listadoDeTipos() {
      const tipos = {};
      this.tipos.forEach(({ id, name }) => {
        tipos[id] = name;
      });
      return tipos;
    },
  },
};
